import { render } from "./Contacto.vue?vue&type=template&id=11e2d64e&scoped=true"
const script = {}

import "./Contacto.vue?vue&type=style&index=0&id=11e2d64e&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e2d64e"]])

export default __exports__